import React from 'react';
import Joi from 'joi';
import {Text, RadioGroup, AutoAddition} from 'components/forms/fields';
import fields from 'components/forms/uscgaops/fields';
import useFieldData from 'components/forms/hooks/useFieldData';
import {Typography} from '@material-ui/core';
import {castToNumber} from 'utils/cast';
import EndSection from 'components/forms/EndSection';
import {SiteUrls} from '../../../../constants';
import sanitizeData from 'components/forms/sections/Review/sanitizer';

const schema = {
    aops_uscg_uw_hours_total: Joi.number().positive().required(),
    _position_listed: Joi.boolean(),
    aops_uscg_uw_hours_coxswain: Joi.array().required(),
    aops_uscg_uw_hours_engineer: Joi.array().required(),
    watertype: Joi.string().required(),
};

const initialValues = {
    aops_uscg_uw_hours_total: null,
    _position_listed: '',
    aops_uscg_uw_hours_coxswain: [],
    aops_uscg_uw_hours_engineer: [],
    watertype: '',
};

const sanitize = data => {
    return sanitizeData({
        aops_uscg_uw_hours_coxswain: [],
        aops_uscg_uw_hours_engineer: [],
        ...data,
    });
};

const RankRating = props => {
    const [positionListed, setPositionListed] =
        useFieldData('_position_listed');

    const updatePositionListed = e => {
        setPositionListed(e.target.value);
    };

    return (
        <EndSection
            {...props}
            {...{schema, initialValues}}
            endpointOverride='uscg_aops'
            redirectUrl={SiteUrls.SEA_SERVICE_DOCS}
            sanitizeFunction={sanitize}
        >
            <Typography variant='h6' align='left'>
                Position / Competency
            </Typography>
            <Typography variant='body1'>
                Let's start by entering information for the grand total hours on
                your AOPS
            </Typography>
            <Text
                name={fields.aops_uscg_uw_hours_total.name}
                label={fields.aops_uscg_uw_hours_total.label}
                inputProps={{
                    type: 'number',
                }}
                transform={castToNumber}
            />
            <RadioGroup
                row
                name={fields._position_listed.name}
                label={fields._position_listed.label}
                onChange={updatePositionListed}
                options={{
                    true: 'Yes',
                    false: 'No',
                }}
            />
            {positionListed === 'true'
                ? [
                      <AutoAddition
                          required
                          name={fields.aops_uscg_uw_hours_coxswain.name}
                          label={fields.aops_uscg_uw_hours_coxswain.label}
                          description={
                              fields.aops_uscg_uw_hours_coxswain.description
                          }
                          totalText='Total U/W Hours on AOPS for Coxswain: ##'
                          dataHeading='Hours'
                      />,
                      <AutoAddition
                          required
                          name={fields.aops_uscg_uw_hours_engineer.name}
                          label={fields.aops_uscg_uw_hours_engineer.label}
                          description={
                              fields.aops_uscg_uw_hours_engineer.description
                          }
                          totalText='Total U/W Hours on AOPS for Engineer: ##'
                          dataHeading='Hours'
                      />,
                  ]
                : null}
            <RadioGroup
                required
                name={fields.watertype.name}
                label={fields.watertype.label}
                options={{
                    'Near Coastal': 'Near Coastal',
                    Inland: 'Inland',
                    'Great Lakes': 'Great Lakes',
                    'Western Rivers': 'Western Rivers',
                }}
            />
            {props.children}
        </EndSection>
    );
};

export default RankRating;
